goog.provide('el8.ptdata.model.pharmacyPrescription');

goog.require('el8.model.base');

/**
 * This model is used to hold "prescription_requested" in a PharmacyPrescriptionRequest
 */
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('authRefills');
    _class.addStringProperty('directions');
    _class.addStringProperty('displayedMedicationName');
    _class.addStringProperty('displayType');
    _class.addBoolean('documentMed');
    _class.addBoolean('eRx');
    _class.addStringProperty('indication');
    _class.addIntProperty('medicationId');
    _class.addStringProperty('noteFromPharmacy');
    _class.addIntProperty('numSamples');
    _class.addIntProperty('quantity');
    _class.addStringProperty('quantityUnits');
    _class.addBoolean('surescripts');

    el8.ptdata.model.pharmacyPrescription = function(spec) {
      return new _class(spec);
    };
})();
